import { Component, OnInit } from "@angular/core";
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html"
})
export class PageNotFoundComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService) {
    this.jsLoader.loadScripts();
  }

  ngOnInit() {}
}
